import React, { Component } from "react";

import { connect } from "react-redux";

import Breadcrumb from "../../../components/Breadcrumb";
import Loading from "../../../components/Loading";
import ProtectedRoute from "../../../components/ProtectedRoute";
import StiftIntegrationComponent from "../../../components/StiftIntegrationComponent/StiftIntegrationComponent";

class StiftView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true
    };
  }

  componentDidMount() {
    if (
      this.props.user.user_roles.filter(
        role => role.group_id === 61 || role.group_id === 62
      ).length === 0
    ) {
      this.props.history.push(`/dashboard`);
    }

    this.setState({ loading: false });
  }

  render() {
    return (
      <>
        <Breadcrumb current={this.props.currentRoute} />
        {this.state.loading ? (
          <div className="p-4">
            <Loading />
          </div>
        ) : (
          <StiftIntegrationComponent userData={this.props.user} />
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

export default connect(mapStateToProps)(StiftView);
